export default "__VITE_ASSET__HWpWGccL__"